import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import {
  IDeltaHedgeExeCommonSearchParam,
  IDetailProcessReport,
} from "../../../Interfaces/deltaHedgeExe";
import { getProcessTable } from "../../../Requests/deltaHedgeExe";
import { Additional } from "./Additional";

interface IProps {
  searchParams: IDeltaHedgeExeCommonSearchParam;
}

const DetailProcessTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IDeltaHedgeExeCommonSearchParam, IDetailProcessReport>
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          AdditionalBody={Additional}
        />
      )}
      getDataTable={getProcessTable}
      searchParameters={searchParams}
    />
  );
};

export default DetailProcessTable;
